import { SEO } from '../components/SEO';
import { HeroSection } from '../components/sections/HeroSection';
import { AboutSection } from '../components/sections/AboutSection';
import { ServicesSection } from '../components/sections/ServicesSection';
import { ResearchSection } from '../components/sections/ResearchSection';
import { ContactCTASection } from '../components/sections/ContactCTASection';

export default function HomePage() {
  const personSchema = {
    "@context": "https://schema.org",
    "@type": "Person",
    "name": "Siddharth Kaul",
    "jobTitle": "Associate Director of Cloud, SRE, DevOps & AI Infrastructure",
    "description": "Cloud, SRE, DevOps & AI Infrastructure Consultant specializing in multi-cloud strategy, AI/ML platforms, site reliability engineering, incident forensics, and DevSecOps transformations for Fortune 500 companies",
    "url": "https://siddharthkaul.com",
    "sameAs": [
      "https://linkedin.com/in/siddharth-k-8b41b619",
      "https://siddharthkaul.substack.com"
    ],
    "knowsAbout": [
      "Cloud Architecture",
      "AI Infrastructure",
      "Kubernetes",
      "DevSecOps",
      "DevOps",
      "Multi-cloud Strategy",
      "Site Reliability Engineering",
      "MLOps",
      "Observability",
      "Incident Response",
      "Incident Forensics",
      "Cost Optimization",
      "Infrastructure as Code",
      "Security Governance"
    ],
    "email": "sidd@siddharthkaul.com"
  };

  return (
    <main data-testid="home-page">
      <SEO
        title="Cloud, SRE, DevOps & AI Infrastructure Consultant | Enterprise Expert"
        description="Siddharth Kaul helps Fortune 500 companies modernize cloud infrastructure, implement site reliability engineering, deploy AI/ML platforms, and optimize DevOps practices. Specializing in incident forensics, observability, and multi-cloud architecture."
        keywords="cloud infrastructure consultant, SRE consultant, DevOps expert, AI infrastructure, site reliability engineering, incident forensics, MLOps, observability, multi-cloud strategy, Kubernetes consulting, cloud cost optimization, enterprise cloud architecture"
        canonicalUrl="/"
        schema={personSchema}
      />
      <HeroSection />
      <AboutSection />
      <ResearchSection />
      <ServicesSection />
      <ContactCTASection />
    </main>
  );
}
